import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'antd';
import { getEventNameByReportType } from '../../../../../../Analytics/Report/ReportEventUtils';
import reportPortalMessages from '../../../../ReportPortalMessages';

export default function SaveQueryButton(props) {
  const { onClick, disabled, loading, type } = props;
  return (
    <Button
      shape="round"
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      sk-event-name={getEventNameByReportType(type, 'saveQuery')}
    >
      <FormattedMessage {...reportPortalMessages.saveQueryButton} />
    </Button>
  );
}
